import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Stagger, StaggerItem } from "./Reveal";
import { SERVICES } from "../data/content";

export const ServiceCards = ({ className = "" }) => (
    <Stagger className={`grid md:grid-cols-2 gap-5 ${className}`}>
        {SERVICES.map((o) => (
            <StaggerItem key={o.id} className="h-full">
                <div
                    className={`p-7 sm:p-9 h-full rounded-xl border flex flex-col ${
                        o.featured
                            ? "bg-navy-900 border-navy-900 shadow-[0_8px_28px_rgba(11,21,38,0.25)]"
                            : "bg-white border-navy-900/10 shadow-[0_1px_3px_rgba(11,21,38,0.06)]"
                    }`}
                    data-testid={`service-card-${o.id}`}
                >
                    <span className={`self-start font-mono text-[10px] tracking-[0.2em] uppercase rounded-full px-3 py-1.5 ${o.featured ? "bg-gold-500 text-navy-950 font-semibold" : "border border-navy-900/20 text-gold-700"}`}>
                        {o.badge}
                    </span>
                    <h3 className={`font-serif font-semibold text-2xl sm:text-[1.7rem] mt-5 ${o.featured ? "text-white" : "text-ink"}`}>{o.title}</h3>
                    <p className={`font-mono text-sm mt-2 ${o.featured ? "text-gold-400" : "text-gold-700"}`}>{o.investment}</p>
                    <p className={`text-[11px] font-mono tracking-widest uppercase mt-1 ${o.featured ? "text-slate-400" : "text-navy-900/45"}`}>{o.timeframe}</p>
                    <p className={`leading-relaxed mt-5 ${o.featured ? "text-slate-200" : "text-ink/85"}`}>{o.who}</p>
                    <p className={`font-mono text-[10px] tracking-[0.22em] uppercase mt-6 ${o.featured ? "text-gold-400" : "text-gold-700"}`}>
                        {o.id === "advisory-retainer" ? "What's included" : "Typical projects"}
                    </p>
                    <ul className="mt-3 space-y-2.5 flex-1">
                        {o.includes.map((item) => (
                            <li key={item} className={`flex gap-3 text-sm leading-relaxed ${o.featured ? "text-slate-300/90" : "text-warmgrey"}`}>
                                <Check size={15} className={`mt-1 shrink-0 ${o.featured ? "text-gold-400" : "text-gold-600"}`} />
                                {item}
                            </li>
                        ))}
                    </ul>
                    <Link
                        to={o.href}
                        data-testid={`service-cta-${o.id}`}
                        className={`mt-8 self-start inline-flex items-center gap-2 text-sm font-semibold px-5 py-2.5 rounded-md transition-colors duration-200 ${
                            o.featured ? "bg-gold-500 text-navy-950 hover:bg-gold-400" : "btn-outline-ink"
                        }`}
                    >
                        {o.cta} <ArrowRight size={15} />
                    </Link>
                </div>
            </StaggerItem>
        ))}
    </Stagger>
);
